module.exports = __webpack_public_path__ + "static/media/test4_2.cd05a389.png";